import React from "react";
import { ArrowRightCircle, ShieldCheck, Users } from "lucide-react";
import { REFUND_DAYS } from "../../config/subscription.js";
import "./hero2.css";

function CustomVideo({ videoId }) {
  const src = `https://iframe.mediadelivery.net/embed/236258/${videoId}?autoplay=false&loop=false&muted=false&preload=true&responsive=true`;
  return (
    <div className="de-hero-video-wrapper">
      <iframe 
        src={src}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" 
        allowFullScreen={true}
        title="Curso Domínio Elétrico"
        className="de-hero-iframe"
      ></iframe>
    </div>
  );
}

function Hero2() {
  return (
    <section className="de-hero">
      <div className="de-hero-container">
        
        {/* COLUNA DA ESQUERDA: TEXTOS E CTA */}
        <div className="de-hero-text-side">
          
          <h1 className="de-hero-title">
            Chega de passar sufoco com <span>Circuitos Elétricos</span> na faculdade.
          </h1>
          
          <p className="de-hero-subtitle">
            Aprenda circuitos elétricos aqui conosco. Domine a matéria, garanta sua aprovação e não perca tempo repetindo semestres.
          </p>

          <p className="de-hero-outcome">
            Circuitos I, II e III · teoria, exercícios e labs · suporte com o professor
          </p>

          <div className="de-hero-actions">
            <a href="#form" className="de-hero-cta">
              Quero ser aluno <ArrowRightCircle size={20} />
            </a>
          </div>

          <div className="de-hero-social-proof">
            <div className="de-proof-item">
              <Users size={16} /> <span>+1.000 alunos</span>
            </div>
            <div className="de-proof-item">
              <ShieldCheck size={16} /> <span>Acesso imediato</span>
            </div>
            <div className="de-proof-item">
              <ShieldCheck size={16} /> <span>Garantia de {REFUND_DAYS} dias</span>
            </div>
          </div>
        </div>

        {/* COLUNA DA DIREITA: VÍDEO */}
        <div className="de-hero-video-side">
          <CustomVideo videoId={"8efc1250-c0e0-4b9b-b234-ef2285afcc33"} />
        </div>

      </div>
    </section>   
  );
}

export default Hero2;